import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Assets/Warranties'

export default createChildListViewContainer()(Component)
